// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__137FX","dragIcon":"SortableItem_dragIcon__1BX_O","disabled":"SortableItem_disabled__2BSXt"};